module.exports = __webpack_public_path__ + "static/media/album-d1.099a7ff9.png";